import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import dayjs from 'dayjs';
import { DataProviderInstance } from '../../api/DataProvider';

/**
 * Data do último backup da plataforma em texto curto (pt-BR):
 * "hoje às HH:mm" / "ontem às HH:mm" / "DD/MM/YYYY às HH:mm".
 */
const formatBackupDate = (dateString) => {
    const date = dayjs(dateString);
    const now = dayjs();
    const time = date.format('HH:mm');

    if (date.isSame(now, 'day')) return `hoje às ${time}`;
    if (date.isSame(now.subtract(1, 'day'), 'day')) return `ontem às ${time}`;

    return `${date.format('DD/MM/YYYY')} às ${time}`;
};

/**
 * Bloco "Seus dados estão protegidos": mostra quando foi a última cópia de
 * segurança feita pela plataforma (independente da exportação da clínica).
 */
const BackupStatusCard = () => {
    const { GetBackupStatus } = DataProviderInstance();
    const [lastBackupAt, setLastBackupAt] = useState(undefined);

    useEffect(() => {
        GetBackupStatus((data) => {
            setLastBackupAt(data && !data.error ? (data.lastBackupAt || null) : null);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const statusText = lastBackupAt
        ? `Última cópia de segurança da plataforma: ${formatBackupDate(lastBackupAt)}.`
        : 'Sem informação disponível no momento.';

    return (
        <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Seus dados estão protegidos
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <VerifiedUserOutlinedIcon fontSize="small" color="success" sx={{ mt: '2px' }} />
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    <Typography variant="body2">{statusText}</Typography>
                    <Typography variant="caption" color="text.secondary">
                        A Gabriela faz cópias diárias do banco de dados. A exportação abaixo é a sua própria cópia, para guardar ou levar para outro sistema.
                    </Typography>
                </Box>
            </Box>
        </Paper>
    );
};

export default BackupStatusCard;
